import { ExpectedStockingDatePopupProps } from 'components/Pages/ProductDetail/ProductDetailAvailability/ExpectedStockingDatePopup';
import { useSettings } from 'connectors/Settings/Settings';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { useCallback } from 'react';
import { useSessionStore } from 'store/useSessionStore';
import twMerge from 'utils/twMerge';

const ExpectedStockingDatePopup = dynamic<ExpectedStockingDatePopupProps>(() =>
    import('components/Pages/ProductDetail/ProductDetailAvailability/ExpectedStockingDatePopup').then(
        (component) => component.ExpectedStockingDatePopup,
    ),
);

type ProductStockProps = {
    quantity: number;
    minimumSellingQuantity?: number;
    supplyDate?: string | null;
};

export const ProductStock: FC<ProductStockProps> = ({
    quantity,
    minimumSellingQuantity = 1,
    supplyDate,
    className,
}) => {
    const { t } = useTranslation();
    const settings = useSettings();
    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);
    const supplyDateMessage = supplyDate ? `${t('Expected stocking date')}: ${supplyDate}` : undefined;

    const stockClickHandler = useCallback(() => {
        if (supplyDate) {
            updatePortalContent(<ExpectedStockingDatePopup supplyDate={supplyDate} />);
        }
    }, [supplyDate, updatePortalContent]);

    const b2bExplicitProductQuantityLimit = settings?.b2bExplicitProductQuantityLimit ?? 10;

    if (quantity < minimumSellingQuantity) {
        return (
            <>
                <div
                    className={twMerge('mt-2 text-small font-medium leading-4 text-grayDark', className)}
                    title={supplyDateMessage}
                    onClick={stockClickHandler}
                >
                    {t('Unavailable')}
                </div>
            </>
        );
    }

    return (
        <div className={twMerge('mt-2 text-small font-medium leading-4 text-green', className)}>
            {quantity > b2bExplicitProductQuantityLimit
                ? `${t('Available > {{ count }} pcs', { count: b2bExplicitProductQuantityLimit })}`
                : `${t('Available {{ quantity }} pcs', { quantity: quantity, count: quantity })}`}
        </div>
    );
};
